// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import I18n from 'i18n-js';
import React from 'react';

import { formatInternationalizedSeconds } from '../lib/date_utils';
import { Item2OrderDetailsDataFragment, core_apimessages_Order_Status } from '@reverbdotcom/commons/src/gql/graphql';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';

const REVERSED_STATUSES = [
  core_apimessages_Order_Status.CANCELLED,
  core_apimessages_Order_Status.LAYAWAY_FORFEITED,
  core_apimessages_Order_Status.REFUNDED,
];

interface IProps extends IUserContext {
  orders: Item2OrderDetailsDataFragment['orders'];
}

type Node = Item2OrderDetailsDataFragment['orders']['nodes'][0];

export const Item2OrderDetailsFragment = gql`
  fragment Item2OrderDetailsData on Listing {
    _id
    orders(input: { as: BUYER }) @skip(if: $loggedOut) {
      nodes {
        _id
        legacyOrderId
        status
        paidAt {
          seconds
        }
        orderUrl {
          href
        }
        createdAt {
          seconds
        }
      }
    }
  }
`;

function getSeconds(node: Node): number {
  if (node.status === core_apimessages_Order_Status.UNPAID || !node.paidAt.seconds) {
    return node.createdAt.seconds;
  }

  return node.paidAt.seconds;
}

function Item2OrderDetails(props: IProps) {
  if (props.user.loggedOut) { return null; }
  const { nodes } = props.orders;
  if (nodes.length === 0) { return null; }

  const [order] = nodes;
  if (REVERSED_STATUSES.includes(order.status)) { return null; }

  return (
    <div className="item2_order-banner">
      <div className="item2_order-banner__text">
        {I18n.t('discovery.item2OrderDetails.datePurchased', {
          date: formatInternationalizedSeconds(getSeconds(order)),
        })}
      </div>
      <CoreLink
        data-order-details-link
        to={nodes[0].orderUrl.href}
        className="item2_order-banner__link"
      >
        {I18n.t('discovery.item2OrderDetails.orderLink', {
          orderNumber: order.legacyOrderId,
        })}
      </CoreLink>
    </div>
  );
}

export default withUserContext(Item2OrderDetails);
